import React from "react";

import { Preview } from "@creatomate/preview";
import { Dropdown, Icon } from "@culturehq/components";

import { Trans, t } from "app/utils";
import BurnSubtitleField from "../BurnSubtitleField";

interface BurnOptionProps {
  activeLanguageCode?: string;
  preview: Preview;
}

const BurnOption: React.FC<BurnOptionProps> = ({
  activeLanguageCode, preview
}) => (
  <div className="boolean-field-option">
    <Dropdown.Option className="DownloadDp-Option" value="burn_subtitles">
      <Icon icon="paste-text" />
      <Trans>Burn Subtitles</Trans>
    </Dropdown.Option>
    <div role="tablist" aria-label={t("Subtitles options")} className="nav nav-tabs">
      <div className="field-options">
        <BurnSubtitleField
          activeLanguageCode={activeLanguageCode}
          preview={preview}
        />
      </div>
    </div>
  </div>
);

export default BurnOption;
